import { createTheme } from '@material-ui/core'
import { hexToRgb } from './core/react-helpers'
import grey from '@material-ui/core/colors/blueGrey'
const theme = createTheme({
  overrides: {
    MuiTypography: {
      h1: {
        fontFamily: 'Bitter, serif',
      },
      h2: {
        fontFamily: 'Bitter, serif',
      },
      h3: {
        fontFamily: 'Bitter, serif',
      },
      h4: {
        fontFamily: 'Bitter, serif',
      },
      h5: {
        fontFamily: 'Bitter, serif',
      },
      h6: {
        fontFamily: 'Bitter, serif',
      },
      subtitle1: {
        fontFamily: 'Bitter, serif',
      },
      subtitle2: {
        fontFamily: 'Bitter, serif',
      },
      body1: {
        fontFamily: 'Inter, sans-serif',
      },
      body2: {
        fontFamily: 'Inter, sans-serif',
      },
      button: {
        fontFamily: 'Inter, sans-serif',
      },
      caption: {
        fontFamily: 'Inter, sans-serif',
      },
    },
    MuiAvatar: {
      root: {
        fontFamily: 'Bitter, serif',
      },
    },
    MuiListSubheader: {
      root: {
        fontFamily: 'Inter, sans-serif',
      },
    },
    MuiFormHelperText: {
      root: {
        fontFamily: 'Inter, sans-serif',
        '& svg': {
          verticalAlign: 'bottom',
          marginRight: 4,
        },
      },
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        color: '#757575',
      },
    },
    MuiStepper: {
      root: {
        backgroundColor: 'unset',
      },
    },
    MuiStepIcon: {
      root: {
        color: '#5B6886',
      },
      active: {
        color: '#1B63A2 !important',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 6,
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiPaper: {
      root: {
        '&:focus-visible': {
          outline: '3px solid #204667',
          outlineOffset: 3,
          zIndex: 1000,
        },
      },
    },
    MuiChip: {
      label: {
        fontFamily: 'Inter, sans-serif',
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 16,
      },
      root: {
        zIndex: '1050 !important',
      },
    },
    MuiDialogTitle: {
      root: {
        '& > h2': {
          fontSize: '1.875em',
          fontWeight: 600,
        },
      },
    },
    MuiButtonBase: {
      root: {
        '&.Mui-focusVisible': {
          outline: '3px solid #204667',
          outlineOffset: 4,
          zIndex: 1000,
        },
      },
    },
    MuiButton: {
      label: {
        fontFamily: 'Inter, sans-serif',
      },
      containedPrimary: {
        height: 36,
        borderRadius: '8px',
        padding: '12px',
        color: '#ffffff',
        backgroundColor: '#204667',
        '&$disabled': {
          color: 'rgba(0,0,0,0.26)',
          backgroundColor: grey[50],
        },
      },
      outlinedPrimary: {
        height: 36,
        borderRadius: '8px',
        padding: '12px',
        '&:hover': {
          backgroundColor: '#ECECEE',
        },
      },
      textPrimary: {
        height: 36,
        '&$disabled': {
          color: 'rgba(0,0,0,0.26)',
          backgroundColor: grey[50],
        },
      },
      root: {
        borderRadius: '8px',
        '&$disabled': {
          borderRadius: '8px',
          padding: '12px',
          color: 'rgba(0,0,0,0.26)',
          backgroundColor: grey[50],
        },
        '&:hover': {
          backgroundColor: '#ECECEE',
        },
      },
    },
    MuiInputBase: {
      root: {
        fontFamily: 'Inter, sans-serif',
        '& .Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.65)', // (default alpha is 0.38)
        },
      },
      input: {},
    },
    MuiMenuItem: {
      root: {
        fontFamily: 'Inter, sans-serif',
      },
    },
    MuiFormLabel: {
      root: {
        fontFamily: 'Inter, sans-serif',
        color: 'rgba(117,118,121,1)',
      },
    },
    MuiTab: {
      root: {
        fontFamily: 'Inter, sans-serif',
      },
      textColorPrimary: {
        color: '#717173',
      },
    },
  },
  shape: {
    borderRadius: 4,
  },
  palette: {
    primary: {
      main: '#204667',
      dark: '#204566',
    },
    avatar: {
      background: `rgba(${hexToRgb('#2fafcc')}, 0.2)`,
    },
    secondary: {
      main: '#204667',
    },
    tertiary: {
      main: '#39BBC0',
      disabled: '#C3EAEC',
      // main: `rgba(${hexToRgb('#2fafcc')}, 0.75)`
    },
    quarternary: {
      main: '#006F84',
      disabled: '#a2bfcd',
      // main: `rgba(${hexToRgb('#204566')}, 0.75)`
    },
    text: {
      primary: '#1c1d1f',
      caption: 'rgb(113,113,115)',
      secondary: '#c7c9cC',
      link: '#36c9eb',
      disabled: '#c7c9cC',
    },
    error: {
      main: '#CF0000',
    },
    background: {
      main: '#f9fafc',
      dropShadow: '0px 12px 24px rgba(32, 69, 102, 0.2)',
    },
    appBar: {
      background: '#ffffff',
    },
    warn: {
      main: '#ED9D66',
    },
    cta: {
      main: '#2380cf',
    },
  },
  zIndex: {
    drawer: 1200,
  },
  dimens: {
    radius: 16,
    spacing: 8,
    text: {
      normal: 16,
      caption: 12,
      title: 40,
    },
    drawerWidth: 350,
    mobileDrawerWidth: 340,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      mini: 744,
      pro: 834,
      md: 960,
      lg: 1280,
      screen: 1440,
      xl: 1920,
    },
  },
})
export default theme
